import React from 'react'
import { Typography, Box } from '@mui/material'

const Privacy: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Privacy
      </Typography>
      <Typography gutterBottom>
        This is the Privacy page with privacy policy information.
      </Typography>
    </Box>
  )
}

export default Privacy
